module.exports = __webpack_public_path__ + "due-invoices-icon.png?becd7a8443c94ac8534950fdfaeb671d";